import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

function getRoute(path, name, meta, component) {
  return {
    path: path,
    name: name,
    meta: meta,
    component: () => component
  };
}
const routes = [
  getRoute('/', 'Empty', { layout: 'sem-sidebar' }, import('./views/Home/Home.vue')),
  getRoute('/home', 'Home', { layout: 'sem-sidebar' }, import('./views/Home/Home.vue')),
  getRoute('/buttons', 'Buttons', { layout: 'sem-sidebar' }, import('./views/Exemplos/Buttons.vue')),
  getRoute('/aluno', 'Aluno', { layout: 'com-sidebar' }, import('./views/Aluno/PerfilAluno/PerfilAluno.vue')),
  getRoute('/quadroHorarioSalaNormal', 'QuadroHorárioSalaNormal', { layout: 'com-sidebar' }, import('./views/Aluno/QuadroHorario/QuadroHorarioSalaNormal.vue')),
  getRoute('/quadroHorarioSalaEspecial', 'QuadroHorarioSalaEspecial', { layout: 'com-sidebar' }, import('./views/Aluno/QuadroHorario/QuadroHorarioSalaEspecial.vue')),
  getRoute('/historicoescolar', 'HistoricoEscolar', { layout: 'com-sidebar' }, import('./views/Aluno/HistoricoEscolar/HistoricoEscolar.vue')),
  getRoute('/situacaoacademica', 'Situação Acadêmica', { layout: 'com-sidebar' }, import('./views/Aluno/SituacaoAcademica/SituacaoAcademica.vue')),
  getRoute('/mensalidadesativos', 'MensalidadesAtivos', { layout: 'com-sidebar' }, import('./views/Aluno/Mensalidades/MensalidadesAtivos.vue')),
  getRoute('/mensalidadescancelados', 'MensalidadesCancelados', { layout: 'com-sidebar' }, import('./views/Aluno/Mensalidades/MensalidadesCancelados.vue')),
  getRoute('/mensalidadesvalorbruto', 'MensalidadesValorBruto', { layout: 'com-sidebar' }, import('./views/Aluno/Mensalidades/MensalidadesValorBruto.vue')),
  getRoute('/servicoAtivo', 'Serviço Ativo', { layout: 'com-sidebar' }, import('./views/Aluno/Servico/ServicoAtivo.vue')),
  getRoute('/servicoCancelado', 'Serviço Cancelado', { layout: 'com-sidebar' }, import('./views/Aluno/Servico/ServicoCancelado.vue')),
  getRoute('/creditos', 'Creditos', { layout: 'com-sidebar' }, import('./views/Aluno/Creditos/Creditos.vue')),
  getRoute('/beneficioAtivo', 'BeneficioAtivo', { layout: 'com-sidebar' }, import('./views/Aluno/Beneficio/BeneficioAtivo.vue')),
  getRoute('/beneficioExcluido', 'BeneficioExcluido', { layout: 'com-sidebar' }, import('./views/Aluno/Beneficio/BeneficioExcluido.vue')),
  getRoute('/beneficioHistorico', 'BeneficioHistorico', { layout: 'com-sidebar' }, import('./views/Aluno/Beneficio/BeneficioHistorico.vue')),
  getRoute('/baseanaliticafies', 'BaseAnaliticaFies', { layout: 'com-sidebar' }, import('./views/Aluno/Fies/BaseAnaliticaFies.vue')),
  getRoute('/fiesAditamento', 'FiesAditamento', { layout: 'com-sidebar' }, import('./views/Aluno/Fies/FiesAditamento.vue')),
  getRoute('/prouni', 'Prouni', { layout: 'com-sidebar' }, import('./views/Aluno/Prouni/Prouni.vue')),
  getRoute('/chamado', 'Chamado', { layout: 'com-sidebar' }, import('./views/Aluno/Chamado/Chamado.vue')),
  getRoute('/pamRecalculo', 'PamRecalculo', { layout: 'com-sidebar' }, import('./views/Aluno/Pam/PamRecalculo.vue')),
  getRoute('/pamTrocaTurma', 'PamTrocaTurma', { layout: 'com-sidebar' }, import('./views/Aluno/Pam/PamTrocaTurma.vue')),
  getRoute('/carneAtivo', 'CarneAtivo', { layout: 'com-sidebar' }, import('./views/Aluno/Carne/CarneAtivo.vue')),
  getRoute('/francesinha', 'Francesinha', { layout: 'com-sidebar' }, import('./views/Aluno/Francesinha/Francesinha.vue')),
  getRoute('/carneDeletado', 'CarneDeletado', { layout: 'com-sidebar' }, import('./views/Aluno/Carne/CarneDeletado.vue')),
  getRoute('/termoscontrato', 'TermosContrato', { layout: 'com-sidebar' }, import('./views/Aluno/TermosContrato/TermosContrato.vue')),
  getRoute('/acordo', 'Acordo', { layout: 'com-sidebar' }, import('./views/Aluno/Acordo/Acordo.vue')),
  getRoute('/raid', 'Raid', { layout: 'sem-sidebar' }, import('./views/Aluno/Raid/Raid.vue')),
  getRoute('/depara', 'DePara', { layout: 'sem-sidebar' }, import('./views/DePara/ExibirRoles.vue')),
  getRoute('/mensalidadescashback', 'MensalidadesCashback', { layout: 'com-sidebar' }, import('./views/Aluno/Mensalidades/MensalidadesCashback.vue')),
  getRoute('/trocaturma', 'Troca de Turma', { layout: 'com-sidebar' }, import('./views/Aluno/TrocaTurma/TrocaTurma.vue')),
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router
